import React from 'react';
import { GenericDetailPage } from '../../../components/generic';
import { usePmsScheduleType, PmsScheduleType } from './useData';
import { moduleConfig, getDetailSections, getStatusBadges } from './config';

const Detail: React.FC = () => (
  <GenericDetailPage<PmsScheduleType>
    useData={usePmsScheduleType}
    config={{
      ...moduleConfig,
      getDetailSections,
      getStatusBadges,
    }}
  />
);

export default Detail;
